import React from 'react';
import FundingCopyableField from './FundingCopyableField';
import { getDevMockSsnFull, isFrontendDevAuthBypassEnabled } from '../../../utils/devAuth';
import { auditClientSsnCopy, revealClientSsn } from '../../../services/funding/fundingIdentityProfilesService';

const SecureSsnField = ({
  maskedValue,
  ssnLast4,
  clientId,
  agencyId,
  profileId,
  applicationId,
  className = '',
  stopPropagation = true,
  testId = 'secure-ssn-field',
}) => {
  const effectiveMasked = maskedValue || (ssnLast4 ? `***-**-${ssnLast4}` : '');

  const reveal = async () => {
    if (!clientId || !agencyId) return null;
    if (isFrontendDevAuthBypassEnabled()) {
      return getDevMockSsnFull(ssnLast4);
    }
    const result = await revealClientSsn(clientId, agencyId, { profileId, applicationId });
    return result?.ssn || null;
  };

  const copy = async ({ revealed, revealedValue }) => {
    if (revealed && revealedValue) {
      if (!isFrontendDevAuthBypassEnabled()) {
        await auditClientSsnCopy(clientId, agencyId, { profileId, applicationId, copyFull: true });
      }
      return revealedValue.replace(/\D/g, '');
    }
    const full = await reveal();
    if (full) {
      if (!isFrontendDevAuthBypassEnabled()) {
        await auditClientSsnCopy(clientId, agencyId, { profileId, applicationId, copyFull: true });
      }
      return full.replace(/\D/g, '');
    }
    return ssnLast4 || null;
  };

  return (
    <FundingCopyableField
      inline
      maskedValue={effectiveMasked || '***-**-****'}
      isSensitive
      canReveal={Boolean(effectiveMasked || ssnLast4)}
      onReveal={reveal}
      onCopy={copy}
      className={`font-medium ${className}`}
      stopPropagation={stopPropagation}
      monospace
      testId={testId}
    />
  );
};

export default SecureSsnField;
